import { memo } from 'react';

import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { RemoteImage } from '@gem/modules/remote-storage';
import { OverlayingPopup } from '@gem/ui-kit';

import styles from './styles.m.css';

const FullScreenImage = ({ url, close }) => {
  return (
    <OverlayingPopup
      isOpened
      onClose={close}
      popupClassName={styles.popup}
    >
      <AddKeyPressHandler onEsc={close} />
      <button
        className={styles.container}
        onClick={close}
      >
        <RemoteImage
          className={styles.img}
          src={url}
          alt=""
        />
      </button>
    </OverlayingPopup>
  );
};

export default memo(FullScreenImage);
